"use client";

import { useEffect } from "react";

export default function AppError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    console.error("[app-error]", error);
  }, [error]);

  const runtimeReloadRecommended =
    /ChunkLoadError|Failed to load chunk|Router action dispatched before initialization|Loading chunk/i
      .test(error.message);

  return (
    <div className="flex h-full min-h-[360px] w-full items-center justify-center bg-white px-6 text-center dark:bg-black">
      <div className="flex max-w-md flex-col items-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-rose-50 text-rose-600 dark:bg-rose-500/10 dark:text-rose-300">
          <span aria-hidden="true" className="text-xl font-black">!</span>
        </div>
        <h1 className="mt-5 text-[20px] font-black text-gray-900 dark:text-gray-100">
          화면을 불러오지 못했습니다
        </h1>
        <p className="mt-2 text-[14px] leading-6 text-gray-500 dark:text-gray-400">
          {runtimeReloadRecommended
            ? "개발 중 변경된 화면 코드와 현재 탭의 버전이 달라졌습니다. 페이지를 새로 불러오면 이어서 사용할 수 있습니다."
            : "일시적인 화면 오류가 발생했습니다. 먼저 다시 시도하고, 계속되면 페이지를 새로 불러와주세요."}
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <button
            type="button"
            onClick={() => unstable_retry()}
            className="rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-[13px] font-bold text-gray-700 transition-colors hover:bg-gray-50 dark:border-[#2a2a2e] dark:bg-[#161618] dark:text-gray-200 dark:hover:bg-[#1f1f22]"
          >
            다시 시도
          </button>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-xl bg-seexr-solid px-4 py-2.5 text-[13px] font-bold text-white transition-colors hover:bg-seexr-solid/90"
          >
            페이지 새로 불러오기
          </button>
        </div>
      </div>
    </div>
  );
}
